// 고객 화면 하단 한 줄 — 견적·계약·현장 링크와 공개 화면 맨 아래에 작은 로고 + 「로 관리되는 현장입니다」(기본 켬).

import { InstantSaveNote } from "@/components/save-bar";
import SectionCard from "@buildpy/ui/section-card";
import { Switch } from "@buildpy/ui/switch";
import { saveBrandFooter } from "@/api/actions/org";
import { useSavedSwitch } from "@/modules/org/ui/settings-portfolio";
import { BRAND_FOOTER_TEXT } from "@buildpy/core/modules/org/brand";

const LABEL = `고객 화면 하단에 『${BRAND_FOOTER_TEXT}』 표시`;

interface Props {
  canEdit: boolean;
  enabled: boolean;
}

const SettingsBrand = ({ canEdit, enabled }: Props) => {
  const footer = useSavedSwitch(enabled, saveBrandFooter);

  return (
    <SectionCard
      actions={canEdit ? <InstantSaveNote /> : undefined}
      data-testid="settings-brand"
      description="고객에게 보내는 견적·계약·현장 링크와 공개 시공사례 화면 맨 아래에 작은 로고와 회색 글씨로 나옵니다. 처음에는 켜져 있습니다."
      title="고객 화면 하단 표시">
      <label className="flex min-h-10 items-center gap-x-2 text-sm" htmlFor="brand-footer">
        <Switch
          aria-label={LABEL}
          checked={footer.checked}
          data-testid="settings-brand-footer"
          disabled={!canEdit || footer.pending}
          id="brand-footer"
          onCheckedChange={footer.onChange}
        />
        <span>{LABEL}</span>
      </label>
    </SectionCard>
  );
};

export default SettingsBrand;
